import { forwardRef } from 'react';
import type { Ref } from 'react';
import clsx from 'clsx';
import type { IconProps } from './Icon.types';
import { Link } from '../Link/Link';

export const Icon = forwardRef<HTMLAnchorElement | null, IconProps>(
  (
    {
      iconClass,
      ariaLabel,
      iconHref,
      trackingProperties,
      children,
      target,
      rel,
      custom_click_track_value,
      ariaLive,
      enableLinkClsName = false,
    },
    ref: Ref<HTMLAnchorElement | null>
  ) => {
    return iconHref ? (
      <Link
        linkHref={iconHref}
        text=""
        ariaLabel={ariaLabel}
        linkClassName={enableLinkClsName ? iconClass || '' : ''}
        trackingProperties={trackingProperties || {}}
        target={target}
        rel={rel}
        custom_click_track_value={custom_click_track_value}
        ref={ref as Ref<HTMLAnchorElement>}
      >
        <span
          data-component-name="a-ui-library-Icon"
          data-testid="ui-library-Icon"
          className={clsx(!enableLinkClsName ? iconClass : '')}
          role="status"
        />
        {children}
      </Link>
    ) : (
      <span
        data-component-name="a-ui-library-Icon"
        data-testid="ui-library-Icon"
        aria-label={ariaLabel}
        aria-live={ariaLive}
        aria-atomic="true"
        className={clsx(iconClass)}
        custom_click_track_value={custom_click_track_value}
        role="status"
      >
        {children}
      </span>
    );
  }
);
